export default __webpack_public_path__ + "static/media/card4.b7d02447.jpg";